export enum InventoryStorageType {
  Rsg = 'RSG_STORAGE',
  OnFarm = 'ON_FARM_STORAGE',
}